import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City');

class Address extends Parse.Object {
  constructor() {
    super('Address');
  }

  get fullAddress () {
    return `${this.get('street')} ${this.get('suburb')} ${this.get('interior')}`
  }

  get street () {
    return this.get('street')
  }

  get suburb () {
    return this.get('suburb')
  }

  get references () {
    return this.get('references')
  }

  get suburb () {
    return this.get('city')
  }

  get interior () {
    return this.get('interior')
  }

  get postalCode () {
    return this.get('postalCode')
  }
  
  get title () {
    return this.get('title')
  }

  get type () {
    return this.get('type')
  }


  get quantity () {
    return this.get('quantity')
  }

  get used () {
    return this.get('used')
  }

  get enabled () {
    return this.get('enabled')
  }

  get price () {
    return this.get('price')
  }

  get location () {
    return this.get('location')
  }

  dump () {
    console.log(this)
  }
}

export default Address
